import Cookies from 'js-cookie';
import en from '@/scripts/languages/en';
import store from '@/scripts/store';
import ru from '@/scripts/languages/ru';
import { isFunction } from '@/scripts/utils';

/*  */
const defaultLanguage = 'en';
const defaultLanguagePack = en;
const languagePacks = { en, ru };
const languages = [
  { id: 'en', name: 'En' },
  { id: 'ru', name: 'Ru' },
];

/*  */
const getLanguagePack = language => languagePacks[language] || languagePacks.en;

const checkBrowserLanguage = () => {
  const languageBrowser = navigator.language;
  let result = null;

  switch (languageBrowser) {
    case 'en-US':
    case 'en':
      return 'en';

    case 'ru':
      return 'ru';

    default:
      break;
  }

  return result;
};

const checkLanguage = languageStore => {
  const languageCookies = Cookies.get('language');
  const languageCookiesIsValid = languages.some(
    ({ id }) => id === languageCookies
  );

  if (languageCookies && languageCookiesIsValid) {
    return languageCookies;
  } else {
    const browserLanguage = checkBrowserLanguage();

    if (browserLanguage && browserLanguage !== languageStore) {
      Cookies.set('language', browserLanguage);

      return browserLanguage;
    } else {
      Cookies.set('language', languageStore);
    }
  }

  return null;
};

const changeLanguage = (language, action) => {
  const languageIsValid = languages.some(({ id }) => id === language);

  if (!languageIsValid) {
    return console.warn(`language "${language}" is not valid`);
  }

  Cookies.set('language', language);

  if (isFunction(action)) action(language);
};

const translateProxy = (key, val, languagePack) => {
  const currentLanguageLevel = languagePack[key];
  const defaultLanguageLevel = defaultLanguagePack[key];

  if (!currentLanguageLevel) {
    console.warn(
      `no such key "${key}" in "${languagePack._language}" language`
    );

    return val;
  }

  if (!defaultLanguageLevel) {
    console.warn(
      `no such key "${key}" in "${defaultLanguagePack._language}" language`
    );

    return val;
  }

  const currentLanguageVal = languagePack[key][val];
  const defaultLanguageVal = defaultLanguagePack[key][val];

  if (typeof currentLanguageVal === 'undefined') {
    console.warn(
      `no such value "${val}" in "${key}" level in "${languagePack._language}" language`
    );
  }

  if (typeof defaultLanguageVal === 'undefined') {
    console.warn(
      `no such value "${val}" in "${key}" level in "${defaultLanguagePack._language}" language`
    );
  }

  return currentLanguageVal || defaultLanguageVal;
};

function applyLanguage(val, forceKey) {
  const languagePack = getLanguagePack(store.state.language);
  const {
    $options: { name = '' },
  } = this;

  const key = forceKey || name;
  const result = translateProxy(key, val, languagePack);

  return result;
}

export {
  defaultLanguage,
  defaultLanguagePack,
  getLanguagePack,
  checkLanguage,
  changeLanguage,
  languages,
  applyLanguage,
  ru,
  en,
};
